import { render, staticRenderFns } from "./addedAutomaticQuotationRule.vue?vue&type=template&id=325f06ea&scoped=true&"
import script from "./addedAutomaticQuotationRule.vue?vue&type=script&lang=js&"
export * from "./addedAutomaticQuotationRule.vue?vue&type=script&lang=js&"
import style0 from "./addedAutomaticQuotationRule.vue?vue&type=style&index=0&id=325f06ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325f06ea",
  null
  
)

export default component.exports